import { memo } from 'react';
import styled from 'styled-components';

import { LessonAttachment } from '../../services/backendService/backendService';
import Poll from '../_organisms/Poll';
import { Slide, SlideElement } from './slide.types';
import SlideElementEditor from './SlideElementEditor';

const EditorSlideViewer = ({
  elements,
  selectedElements,
  aspect,
  slide,
  lessonAttachments,
}: {
  elements: SlideElement[];
  slide: Slide;
  aspect: { width: number; height: number };
  selectedElements: SlideElement[] | null;
  lessonAttachments?: LessonAttachment[];
}) => {
  return (
    <SlideEditorContainer>
      {elements.map(element => (
        <SlideElementEditor
          element={element}
          key={element.id}
          aspect={aspect}
          selectedElements={selectedElements}
          isDiscoverTemplate={false}
          isOwner={true}
          lessonAttachments={lessonAttachments}
        />
      ))}
      {slide.type === 'poll' && slide.pollOptions && (
        <PollContainer>
          <Poll
            staticData={slide.pollOptions.map(e => ({ ...e, count: 0 }))}
            isAuthenticated={true}
            hideCount={true}
          />
        </PollContainer>
      )}
    </SlideEditorContainer>
  );
};

const SlideEditorContainer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 0;
  border-radius: 10px;
  background-color: transparent;
  border-radius: 10px;
  position: relative;
`;

const PollContainer = styled.div`
  position: absolute;
  width: 90%;
  height: 10%;
  background-color: transparent;
  bottom: 25%;
  left: 5%;
`;

export default memo(EditorSlideViewer);
